<template>
  <button @click="startRecording" type="button" class="mr-3">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      class="bi bi-mic-fill"
      viewBox="0 0 16 16"
      v-show="!isRecording"
    >
      <path d="M5 3a3 3 0 0 1 6 0v5a3 3 0 0 1-6 0z" />
      <path
        d="M3.5 6.5A.5.5 0 0 1 4 7v1a4 4 0 0 0 8 0V7a.5.5 0 0 1 1 0v1a5 5 0 0 1-4.5 4.975V15h3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h3v-2.025A5 5 0 0 1 3 8V7a.5.5 0 0 1 .5-.5"
      />
    </svg>

    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      class="bi bi-mic-mute-fill text-danger blink"
      viewBox="0 0 16 16"
      v-show="isRecording"
    >
      <path
        d="M13 8c0 .564-.094 1.107-.266 1.613l-.814-.814A4 4 0 0 0 12 8V7a.5.5 0 0 1 1 0zm-5 4c.818 0 1.578-.245 2.212-.667l.718.719a5 5 0 0 1-2.43.923V15h3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h3v-2.025A5 5 0 0 1 3 8V7a.5.5 0 0 1 1 0v1a4 4 0 0 0 4 4m3-9v4.879L5.158 2.037A3.001 3.001 0 0 1 11 3"
      />
      <path
        d="M9.486 10.607 5 6.12V8a3 3 0 0 0 4.486 2.607m-7.84-9.253 12 12 .708-.708-12-12z"
      />
    </svg>
  </button>
</template>

<script setup>
// eslint-disable-next-line
/* eslint-disable */
import { ref, watch } from "vue";

const recognition = ref(null);

const isTranscripting = ref(false);

const isRecording = ref(false);

const $emit = defineEmits();

const __init = () => {
     recognition.value = new webkitSpeechRecognition();

     recognition.value.interimResults = true;

     recognition.value.onresult = (event) => {
          let query = event.results[0][0].transcript;
          
          $emit('onresult', { transcript: query });

          setTimeout(() => {
               isTranscripting.value = false;
               isRecording.value = false;
          }, 1000);
     };
}

const _isChromeAPIAvailable = () => window.webkitSpeechRecognition !== undefined;

const startTranscription = () => {
     isTranscripting.value = true;
     isRecording.value = true;

     recognition.value.start();
}

const stopTranscription = () => {
     recognition.value.stop();

     isTranscripting.value = false;
     isRecording.value = false;
}

const startRecording = () => {
     if(! _isChromeAPIAvailable()) {
          $emit('unsupported');

          return;
     }

     __init();

     if(isTranscripting.value) {
          stopTranscription();

          return;
     }
     
     startTranscription();
};

watch([recognition, isTranscripting], ([newRecognition, newIsTranscripting], []) => {
     recognition.value.addEventListener('onspeechend', () => {
          isTranscripting.value = false;

          $emit('recordingFinished');
     });

     newIsTranscripting
          ? $emit('recordingStarted')
          : $emit('recordingEnded');
});
</script>

<style scoped>
.blink {
  animation: blink 2s steps(5, start) infinite;
  -webkit-animation: blink 1s steps(5, start) infinite;
}
@keyframes blink {
  to {
    visibility: hidden;
  }
}
@-webkit-keyframes blink {
  to {
    visibility: hidden;
  }
}
</style>
